/// <amd-module name="Widgets/Configs/Common/OpStoreTeamQuery" />
import { ICacheableQuery } from "Reporting/Common/ICacheableQuery";
import { WebApiTeam } from "Tfs/Platform/Contracts/Core";
import { getCoreClient } from "Tfs/Platform/RestClient/Core";
import { IVssPageContext } from "VSS/Platform/Context";

/** Makes a query for a team against the operational store. Only scoped to project */
export class OpStoreTeamQuery implements ICacheableQuery<WebApiTeam> {
    public static onProject(projectId: string, teamId: string): OpStoreTeamQuery {
        return new OpStoreTeamQuery(projectId, teamId);
    }

    private constructor(private projectId: string, private teamId: string) {}

    public getKey(): string {
        return `TeamQuery-CurrentProject-${this.projectId}-${this.teamId}`;
    }

    public async runQuery(pageContext: IVssPageContext): Promise<WebApiTeam> {
        const team = await getCoreClient(pageContext).getTeam(this.projectId, this.teamId);
        return team;
    }
}
